import { render, staticRenderFns } from "./ProyectosPlanificar.vue?vue&type=template&id=3e42a376"
import script from "./ProyectosPlanificar.vue?vue&type=script&lang=js"
export * from "./ProyectosPlanificar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports